module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-list"
  }, [_vm._l((_vm.groupList), function(group, letter) {
    return _c('div', {
      key: letter,
      staticClass: "group"
    }, [_c('div', {
      staticClass: "letter"
    }, [_vm._v(_vm._s(letter))]), _vm._v(" "), _c('ul', _vm._l((group), function(item) {
      return _c('touch', {
        key: item.id,
        attrs: {
          "tag": "li"
        },
        on: {
          "tap": function($event) {
            _vm.joinin(item)
          }
        }
      }, [_c('webp-image', {
        staticClass: "logo",
        attrs: {
          "src": item.icon,
          "alt": "logo"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.name))])], 1)
    }))])
  }), _vm._v(" "), _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "title": "加入战队"
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    }
  }, [_c('p', {
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("确认支持 "), _c('strong', [_vm._v(_vm._s(_vm.selected.name))]), _vm._v(" 战队，"), _c('br'), _vm._v("为它助力！确定后无法更改哦。")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-0b61a58c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GroupList.vue
// module id = 197
// module chunks = 1